import { cn } from '@/core/utils/common'

export type ButtonVariant =
  'primary' | 'secondary' | 'outline' | 'ghost' | 'danger' | 'plain'
export type ButtonSize = 'sm' | 'md' | 'lg' | 'icon'

export const variantStyles: Record<ButtonVariant, string> = {
  primary: 'bg-point text-inverse hover:bg-point/90',
  secondary: 'bg-surface-strong text-foreground hover:bg-border',
  outline:
    'border border-border bg-background text-foreground hover:border-point',
  ghost: 'text-foreground hover:bg-surface-strong',
  danger: 'bg-error text-inverse hover:bg-error/90',
  plain: 'text-foreground hover:text-point',
}

export const sizeStyles: Record<ButtonSize, string> = {
  sm: 'min-h-10 px-3 py-2 text-c13',
  md: 'min-h-12 px-4 py-3 text-c14',
  lg: 'min-h-14 px-6 py-4 text-c15',
  icon: 'size-10 shrink-0',
}

export function buttonClassName(
  variant: ButtonVariant = 'primary',
  size: ButtonSize = 'md'
) {
  return cn(
    'inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-field font-medium',
    'transition-[color,background-color,border-color,opacity] duration-200',
    'active:opacity-80 focus:outline-none focus-visible:opacity-90',
    variantStyles[variant],
    sizeStyles[size]
  )
}
